import axios from "axios";
import { ExportDefinition } from "../../types/model/export/ExportDefinition";
import { UpdateExportDefinitionRequest } from "../../types/model/export/UpdateExportDefinitionRequest";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/exports/admin/export-definitions`;

export const updateExportDefinition = async (
  definitionId: number,
  updates: UpdateExportDefinitionRequest,
): Promise<ExportDefinition> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  return await axios
    .put<ExportDefinition>(`${BASE_URL}/${definitionId}`, updates, {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    })
    .then((response) => response.data);
};